<template>
  <div class="red-reward-button">
    <div class="red-reward-group">
      <div class="red-reward-text">
        <span>答题感谢红包</span>
      </div>
      <div class="chai-btn cursor-pointer" @click="$emit('click')">
        <span class="text-theme-black-650">拆</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RedRewardButton'
}
</script>

<style scoped lang="scss">
.red-reward-group {
  margin: 0 auto;
  width: 286px;
  height: 432px;
  background-image: url('/assets/img/award/red-reward-bg.png');
  background-repeat: no-repeat;
  background-size: contain;
  position: relative;

  .red-reward-text {
    color: #f0ffc8;
    font-size: 24px;
    text-align: center;
    padding-top: 120px;
  }

  .chai-btn {
    background-color: #e8d673;
    width: 88px;
    height: 88px;
    border-radius: 50%;
    position: absolute;
    text-align: center;
    line-height: 88px;

    left: 50%;
    bottom: 60px;
    font-size: 40px;
    transform: translateX(-50%);
  }
}
</style>
